<div class="customer-damage-data">
    <div>
        {{ 'CUSTOMER_DAMAGE_DATA.twoYearsDamagesAmount' | translate }} - <span class="bold">{{ last2YearsOcDamages | translate }}</span>
    </div>
    <div>
        {{ 'CUSTOMER_DAMAGE_DATA.fiveYearsDamagesAmount' | translate }} - <span class="bold">{{ last5YearsOcDamages | translate }}</span>
    </div>
</div>
